/*jshint esversion: 8 */
import { ipsAll } from './ipsAll';

let modeDes   = ''; // 描述
let webhost   = ''; // 前端，用于统一认证返回
let hostIp    = ''; // 后端业务ip端口
let imgHostIp = ''; // 后端图片服务 ip端口
let loginType = ''; // 登陆方式, passowrd: 账号密码; oauth2: 统一认证;
let authClientId = ''; // oauth2: 统一认证客户端编号
let hostName  = ''; // 网站名称
let localStorage  = ''; // localStorage名称

let href  = window.location.href;

for (let i = 0; i < ipsAll.length; i++) {
  const ipInfo = ipsAll[i];
  const ips = ipInfo.ips || [];
  for (let j = 0; j < ips.length; j++) {
    const ip = ips[j];
    if (href.includes(ip)) {
      modeDes   = ipInfo.modeDes    || '';
      webhost   = ipInfo.webhost    || '';
      hostIp    = ipInfo.hostIp     || '';
      imgHostIp = ipInfo.imgHostIp  || '';
      loginType = ipInfo.loginType  || '';
      authClientId  = ipInfo.authClientId || '';
      hostName  = ipInfo.hostName   || '';
      localStorage  = ipInfo.localStorage || '';
      break;
    }
  }
  if (modeDes) break;
}

console.log(`----- get ips, `, modeDes);

export {
  hostIp,
  imgHostIp,
  webhost,
  modeDes,
  loginType,
  authClientId,
  hostName,
  localStorage
};
